<template>
  <div>
    <ComponentOnlineTest />
  </div>
</template>

<script>
import ComponentOnlineTest from "ninenine-white-label/src/components/Tests/ComponentOnlineTest.vue";

export default {
  name: "OnlineTests",
  props: {
    headerTestId: String,
  },

  components: {
    ComponentOnlineTest,
  },
};
</script>

<style lang="scss" scoped>
/deep/.tabs {
  .btn {
    white-space: normal;
  }
}

.check_image {
  width: auto !important;
}

/deep/.check {
  width: 100%;
  height: 100%;
  div {
    margin: 0;
  }
  label {
    border: none !important;
    padding: 15px 15px 15px 45px !important;
    width: 100%;
    display: flex !important;
    margin: 0;

    &::before {
      border: 1px solid theme-color("blue-ml");
      background: white !important;
      width: 25px !important;
      height: 25px !important;
      top: 50% !important;
      left: 10px !important;
      bottom: auto !important;
      margin-top: -12px !important;

      &:hover {
        line-height: 160% !important;
      }
    }
  }

  input[type="checkbox"]:not(:checked) + label:hover:before {
    line-height: 170% !important;
    color: theme-color("blue-ml") !important ;
    content: "";
  }

  input[type="radio"],
  input[type="checkbox"] {
    &:checked + label {
      &:before {
        background: theme-color("blue-ml") !important ;
        color: white;
        line-height: 170% !important;
      }
    }
  }
}

.onlineTest {
  min-height: 100vh;

  .description {
    margin-top: 10px;
    font-size: 14px;
  }

  .image-title {
    img {
      min-width: 250px;
      max-width: 250px;
      height: auto;
    }
  }
}
</style>
